import React, {useState} from "react";
import {Link} from "react-router-dom";

import ItemMedia from '../../components/ItemDetails/ItemMedia';

const WalletInventoryItem = ({v}) => {
    const [isSendNftVisible, setIsSendNftVisible] = useState({status: false});
    
    
    return (<div className="col-12 col-sm-6 col-lg-3 item">
        <div className="card">
            <div className="image-over">
                <Link to={`/item?tokenIdentifier=${v.fullTokenIdentifier}`}>
                    <ItemMedia v={v} />
                </Link>
            </div>
            {/* Card Caption */}
            <div className="card-caption col-12 p-0">
                {/* Card Body */}
                <div className="card-body">
                    <Link to={`/item?tokenIdentifier=${v.fullTokenIdentifier}`}>
                        <h5 className="mb-0 font-weight-normal">{v.name}</h5>
                    </Link>
                    <div className="seller d-flex align-items-center my-3 d-none">
                        <span>Ticker</span>
                        <a href="/author" >
                            <h6 className="ml-2 mb-0 font-weight-normal">{v.tokenIdentifier}</h6>
                        </a>
                    </div>
                    <a className="btn btn-bordered-white btn-smaller mt-3 d-none" href="#" data-toggle="modal" data-target={`#transfer-nft-${v.fullTokenIdentifier}`} >
                        <i className="icon-envelope mr-2" />Send
                    </a>
                    <Link className="btn btn-bordered-white btn-smaller mt-3 " to={`/transfer-item?tokenIdentifier=${v.fullTokenIdentifier}`} >
                        <i className="icon-envelope mr-2" />Send
                    </Link>
                </div>
            </div>
        </div>
    </div>
    )
}

export default WalletInventoryItem;